module.exports = __webpack_public_path__ + "static/img/6.df38c366.png";